// Module
var code = "<section id=\"page-loader\"> <div class=\"loader\"> <div id=\"ld3\"> <div> </div> <div> </div> <div> </div> <div> </div> </div> </div> </section> ";
// Exports
module.exports = code;